// Vardanta World — product catalogue
const U = "https://images.unsplash.com/photo-";
export const img = (base, w = 900) => `${U}${base}?q=80&w=${w}&auto=format&fit=crop`;

export const CATEGORIES = [
  "Specialty Chemicals",
  "Industrial Minerals",
  "Water Treatment",
  "Fertiliser & Agro",
  "Bioscience",
];

export const PRODUCTS = [
  // Specialty Chemicals
  { code: "EMD", name: "Electrolytic Manganese Dioxide", category: "Specialty Chemicals", img: "1648079363698-367afe62e118" },
  { code: "NMD", name: "Natural Manganese Dioxide", category: "Specialty Chemicals", img: "1676721492346-90bf798b6c34" },
  { code: "MnCO₃", name: "Manganese Carbonate", category: "Specialty Chemicals", img: "1593095948071-474c5cc2989d" },
  { code: "ZnO", name: "Zinc Oxide", category: "Specialty Chemicals", img: "1693996045463-6ea86d10a2e7" },

  // Industrial Minerals
  { code: "K-FLD", name: "Potassium Feldspar", category: "Industrial Minerals", img: "1584715787746-75b93b83bf14" },
  { code: "GCC", name: "Ground Calcium Carbonate", category: "Industrial Minerals", img: "1710857389305-5cba9211033f" },

  // Water Treatment
  { code: "MnSO₄", name: "Manganese Sulphate", category: "Water Treatment", img: "1693996046865-19217d179161" },
  { code: "Na₂SO₄", name: "Sodium Sulphate", category: "Water Treatment", img: "1737098140591-f0988ae7e15a" },

  // Fertiliser & Agro
  { code: "SSP", name: "Single Super Phosphate", category: "Fertiliser & Agro", img: "1560493676-04071c5f467b" },
  { code: "MgSO₄", name: "Magnesium Sulphate", category: "Fertiliser & Agro", img: "1774169440279-ff1f9ecfc523" },
  { code: "SOP", name: "Sulphate of Potash", category: "Fertiliser & Agro", img: "1627920769541-daa658ed6b59" },
  { code: "AS", name: "Ammonium Sulphate", category: "Fertiliser & Agro", img: "1615811361523-6bd03d7748e7" },
  { code: "S", name: "Sulphur", category: "Fertiliser & Agro", img: "1598598218968-47720f64c360" },

  // Bioscience
  { code: "BAC", name: "Bacillus Strains", category: "Bioscience", img: "1631824683860-9a7aa1fe0713" },
  { code: "SCLP", name: "S. cerevisiae & L. plantarum", category: "Bioscience", img: "1580377968242-daed42865732" },
  { code: "NIT", name: "Nitrosomonas", category: "Bioscience", img: "1560808193-0d6ef54659ad" },
  { code: "AZR", name: "Azotobacter & Rhodococcus", category: "Bioscience", img: "1708014750399-c0b86e16aea5" },
  { code: "MY8", name: "Mineral Yeast — 8 Variants", category: "Bioscience", img: "1706201320648-34ceff15239a" },
  { code: "FHP", name: "Fulvic & Humic Premix", category: "Bioscience", img: "1693554389001-6a85b5df6fbf" },
  { code: "BOT", name: "Botanical Actives", category: "Bioscience", img: "1585328000852-779be6a6582b" },
  { code: "BIO-C", name: "Custom & Contract Formulation", category: "Bioscience", img: "1533038590840-1cde6e668a91" },
];
